import { render, staticRenderFns } from "./not-allowed.vue?vue&type=template&id=18c3914a"
import script from "./not-allowed.vue?vue&type=script&lang=js"
export * from "./not-allowed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports